export default {
  first_name: 'string',
  last_name: 'string',
  user_paysources: 'array',
  avg_rating: 'number',
  master_rating: 'number',
  id: 'number',
  video: 'string',
  description: 'string',
  organization: 'string',
  public: 'boolean',
  labor_only: 'boolean',
  has_password: 'boolean',
  profile_image: 'object',
  lat: 'number',
  lng: 'number',
  companies: 'hasMany',
  notes: 'hasMany',
  vehicles: 'hasMany',
  locations: 'hasMany',
  gallery: 'hasMany',
  clients: clients => {
    if (!clients) {
      return '<p></p>'
    } else {
      return clients
    }
  }
}
